export default __webpack_public_path__ + "static/media/Cornamusa_Azul.3f4744b1.svg";